import { graphql } from "@/lib/gql/__generated__/gql";

export const OptionList_OptionListPage_Query = graphql(/* GraphQL */ `
	query OptionList_OptionListPage($hotelID: ID!) {
		optionList(hotelID: $hotelID) {
			hotelID
			id
			options {
				billingTypeTarget
				billingTypeTerm
				cancelPolicy {
					beforeDays
					chargeRatio
				}
				description
				hotelID
				id
				inSale
				isNextMorning
				keyVisuals {
					bucket
					fileName
					key
					mimeType
					region
				}
				mainKeyVisual {
					bucket
					fileName
					key
					mimeType
					region
				}
				maxBuyableNumPerTarget
				maxDailyStockNum
				maxStockNum
				minimumBuyableNumPerTarget
				multiSubOptionSelectable
				name
				optionID
				optionType
				price {
					amount
					currencyType
				}
				requiredPrepMillisecond
				saleEnd
				saleStart
				saleStartBeforeDate
				saleTypeForPlan
				saleTypeForTerm
				soldNumTotal
				stayableDayOfTheWeek
				stayableEnd
				stayableStart
				subOptions {
					endAt
					isNextMorning
					isShowTimeSchedule
					maxDailyStockNum
					memo
					name
					startAt
					subOptionID
				}
				useAsSubOption
			}
		}
	}
`);
